import { Payment } from '@payment/const';
import { StateUtils } from '@spartacus/core';
import { PAYMENT_LIST } from '../payment-state';

export const LOAD_PAYMENT_LIST = '[Payment] Load Payment List';
export const LOAD_PAYMENT_LIST_SUCCESS = '[Payment] Load Payment List Success';
export const LOAD_PAYMENT_LIST_FAIL = '[Payment] Load Payment List Fail';
export const RESET_LOAD_PAYMENT_LIST = '[Payment] Reset Load Payment';

export class LoadPaymentList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PAYMENT_LIST;

  constructor() {
    super(PAYMENT_LIST);
  }
}

export class LoadPaymentListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PAYMENT_LIST_SUCCESS;

  constructor(public payload: Payment[]) {
    super(PAYMENT_LIST);
  }
}

export class LoadPaymentListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PAYMENT_LIST_FAIL;

  constructor(public payload: unknown) {
    super(PAYMENT_LIST);
  }
}

export class ResetLoadPaymentList extends StateUtils.LoaderResetAction {
  readonly type = RESET_LOAD_PAYMENT_LIST;

  constructor() {
    super(PAYMENT_LIST);
  }
}

export type PaymentListActions = LoadPaymentList | LoadPaymentListSuccess | LoadPaymentListFail | ResetLoadPaymentList;
